<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.credit_note_types.form.name')"
            :is-required="true"
            :error="errors.name"
            :hint="__('settings.credit_note_types.form.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                :is-valid="isFormFieldValid('name')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.credit_note_types.form.title')"
            :is-required="true"
            :error="errors.title"
            :hint="__('settings.credit_note_types.form.title_hint')"
        >
            <DInput
                id="title"
                v-model="form.title"
                :is-valid="isFormFieldValid('title')"
                maxlength="255"
            />
            <TranslationLink
                :tenant-languages="tenantLanguages"
                :route="$route('settings.credit-note-types.translations', {creditNoteType: creditNoteType?.id ?? 0})"
                :default-tenant-language="defaultTenantLanguage"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === false"
            :label="__('settings.credit_note_types.form.cost_center')"
            :error="errors.cost_center"
            :hint="__('settings.credit_note_types.form.cost_center_hint')"
        >
            <DInput
                id="cost_center"
                v-model="form.cost_center"
                :is-valid="isFormFieldValid('cost_center')"
                type="number"
                min="0"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === true"
            :is-required="true"
            :label="__('settings.credit_note_types.form.netsuite_item_id')"
            :error="errors.netsuite_item_id"
            :hint="__('settings.credit_note_types.form.netsuite_item_id_hint')"
        >
            <DInput
                id="netsuite_item_id"
                v-model="form.netsuite_item_id"
                :is-valid="isFormFieldValid('netsuite_item_id')"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === true"
            :is-required="true"
            :label="__('settings.credit_note_types.form.netsuite_department_id')"
            :error="errors.netsuite_department_id"
            :hint="__('settings.credit_note_types.form.netsuite_department_id_hint')"
        >
            <DInput
                id="netsuite_department_id"
                v-model="form.netsuite_department_id"
                :is-valid="isFormFieldValid('netsuite_department_id')"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.credit_note_types.form.text')"
            :error="errors.text"
            :hint="__('settings.credit_note_types.form.text_hint')"
        >
            <DFormTextarea
                id="text"
                v-model="form.text"
                :is-valid="isFormFieldValid('text')"
            />
            <TranslationLink
                :tenant-languages="tenantLanguages"
                :route="$route('settings.credit-note-types.translations', {creditNoteType: creditNoteType?.id ?? 0})"
                :default-tenant-language="defaultTenantLanguage"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="cancelRouteLink"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
import TranslationLink from '../TranslationLink.vue'

export default {
    name: 'CreditNoteTypeForm',
    components: { TranslationLink },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        creditNoteType: {
            type: String,
            default: ''
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => { return [] }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                name: this.creditNoteType?.name ?? null,
                title: this.creditNoteType?.title ?? null,
                cost_center: this.creditNoteType?.cost_center ?? null,
                text: this.creditNoteType?.text ?? null,
                netsuite_item_id: this.creditNoteType?.netsuite_item_id ?? null,
                netsuite_department_id: this.creditNoteType?.netsuite_department_id ?? null,
                language: this.defaultTenantLanguage.value
            })
        }
    },
    computed: {
        cancelRouteLink () {
            return this.$route('settings.credit-note-types.index')
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
